import { render, staticRenderFns } from "./InformacoesLegais.vue?vue&type=template&id=4602826e&"
import script from "./InformacoesLegais.vue?vue&type=script&lang=js&"
export * from "./InformacoesLegais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports